const envVars = process.env.BASE_URL || process.env.NODE_ENV !== 'production'
    ? process.env
    : ((typeof window !== 'undefined' && window.env_vars) || {});

const baseUrl = envVars.BASE_URL || 'http://localhost:8000/';
const config = {
    version: envVars.APP_VERSION || '',
    url: baseUrl,
    api: envVars.API_URL || `${baseUrl}api`,
    staticUrl: envVars.STATIC_URL || 'https://managexam-assets.s3.fr-par.scw.cloud/',
    ws: envVars.WEBSOCKET_URL || '',
    port: envVars.PORT || 8000,
    application: {
        name: 'App.Managexam.com',
        email: 'contact@managexam.com',
        options: {
            maxApplicantsCountByProctor: 9,
            maxProctorsCountByApplicantInThesis: 5,
            webcamCaptureInterval: 10,
        },
        legal: {
            lastCGUTimestampUpdate: 1596110299, // not used anymore => get config value from Config data
        },
        invoice: {
            prefix: {
                managexam: 'MAI-',
                cff: 'CFFI-',
            },
        },
        quote: {
            prefix: {
                managexam: 'MAQ-',
                cff: 'CFFQ-',
            },
        },
    },
    aws: {
        cognito: {
            region: 'eu-central-1',
            userPoolId: envVars.COGNITO_USER_POOL_ID || 'eu-central-1_Nen785Aik',
            clientId: envVars.COGNITO_CLIENT_ID || '15rumk64snggpr6f96aj7qjla7',
            identityPoolId: envVars.COGNITO_IDENTITY_POOL_ID || 'eu-central-1:1d8bbe2b-f0db-456b-bed9-9f02cfeb58b3',
        },
        s3: {
            region: 'eu-west-3',
            bucket: envVars.S3_BUCKET || 'dev.managexam.com',
        },
        rekognition: {
          region: 'eu-west-1',
        },
    },
    bugsnag: {
        key: envVars.BUGSNAG_KEY || '',
    },
    sentry: {
        dsn: {
            client: envVars.SENTRY_DSN_CLIENT || '',
        },
    },
    twilio: {
    },
    tinymce: {
        key: envVars.TINYMCE_KEY || '',
    },
};

// export default config;
// process.env.NODE_ENV !== 'production' && console.log('client config', config, process.env);
module.exports = config;
